import './Articles.css';
import React from 'react';
import ArticlesItem from './articlesItem/ArticlesItem';
import ProductReview from '../reviews/productReview/ProductReview';
// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';
// Import styles bundle
import 'swiper/css';

function Articles(props) {

  return (
      <>
        {
          props.hasOwnProperty('items') && Array.isArray(props.items) &&
          props.items.length ?
              <section id={'article-list'} className="blog-section">
                <div className="container">
                  <div className="title-container">
                    <div className="blog-category-title left-side-title">
                      {props.title}
                    </div>
                  </div>
                  <div className="blog-container">
                    <div className="blog-list">
                      {
                        props.clientWidth <= 768 ?
                            <Swiper slidesPerView={1}
                                    loop={true}
                                    spaceBetween={10}
                                    breakpoints={{768: {slidesPerView: 3}}}>
                              {
                                props.items.map(article => (
                                    <SwiperSlide key={`article-${article.ID}`}>
                                      <ArticlesItem
                                          {...article}
                                          messages={props.messages}
                                      />
                                    </SwiperSlide>
                                ))
                              }
                            </Swiper> :
                            props.items.map(article => (
                                <ArticlesItem
                                    key={`article-${article.ID}`}
                                    {...article}
                                    messages={props.messages}
                                />
                            ))
                      }
                    </div>
                  </div>
                </div>
              </section> :
              <></>
        }
      </>
  );
}

export default Articles;